import { UserRole } from '@/types/models';

/**
 * Labels for the v2 sidebar's work-order views, shared by the drawer and the pages so a
 * row and the screen it opens always agree on what they are called.
 */

/**
 * "My Work Orders" for anyone with a caseload; "All Open Work Orders" for the roles whose
 * `?scope=mine` the server does not narrow at all (Admin, Accounting).
 */
export const myWorkOrdersLabel = (user: { role?: string } | null | undefined): string =>
	user?.role === UserRole.Admin || user?.role === UserRole.Accounting
		? 'All Open Work Orders'
		: 'My Work Orders';
